import moment from 'moment';
import BaseUserService from './BaseUserService';
import Constants from '../utils/constants';

const path = 'users/internal';

export default class InternalUserService extends BaseUserService {
    // Initializing important variables
    constructor() {
        super(path);
        this.path = path;
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            login: criteria.login,
            first_name: criteria.firstName,
            last_name: criteria.lastName,
            email: criteria.email,
            subcontractor: criteria.subcontractor?.id,
            roles: criteria.roles ? criteria.roles.map((x) => x.id) : [],
            status: criteria.status?.enumValue,
            active: criteria.active,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    getSimpleList(permission) {
        return this.fetch(`${this.domain}/${this.path}/list/simple${permission ? '?permissions=' + permission : ''}`, {
            method: 'GET',
        }).catch((err) => {
            throw err;
        });
    }
    createObjectToSave(element) {
        const e = this.cloneElement(element);
        e.contracts.forEach((contract) => {
            if (contract.dateFrom) {
                contract.dateFrom = moment(contract.dateFrom).startOf('month').format(Constants.DATE_JSON_FORMAT);
            }
            if (contract.dateTo) {
                contract.dateTo = moment(contract.dateTo).startOf('month').format(Constants.DATE_JSON_FORMAT);
            }
        });
        return e;
    }
    
    update(element) {
        return super.update(this.createObjectToSave(element));
    }
    add(element) {
        return super.add(this.createObjectToSave(element));
    }

}
